import { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PreviousRound from "../../previousround/PreviousRound";
import dayjs from "dayjs";
import candidateImg from "../../../assests/candidateImg.png";
import candidateCV from "../../../assests/candidateCV.png";
import { Row, Col, Card, Typography, Divider, Space, Image, Input, Button, DatePicker, Radio, Modal } from "antd";
import moment from "moment";
import SalaryCalculator from "../../../components/SalaryCalculator";

const { Text, Title } = Typography;
const { TextArea } = Input;

export default function HrOneCandidate({ id, lno, onBack }) {
    const { authData, backUrl } = useContext(AuthContext);
    const [showCalculator, setShowCalculator] = useState(false);

    const [offered_notice_period, setOfferedNoticePeriod] = useState(0)
    const [singleData, setSingleData] = useState({});
    const [data, setData] = useState({
        level_number: lno,
        status: "",
        remarks: "",
    });

    const [showAlert, setShowAlert] = useState(false);
    const [viewPrevious, setViewPrevious] = useState(false);
    const [techAssessment, setTechAssessment] = useState({
        tech_qualification: "",
        tech_experience: "",
        tech_knowledge: "",
        tech_skills_rating: "",
        tech_attitude: "",
        tech_communication: "",
        tech_time_management: "",
        tech_flexibility: "",
        tech_commitment: "",
        present_salary: "",
        expected_salary: "",
        offered_salary: "",
        date_of_joining: "",
        is_pf: "Yes",
        is_esi: "Yes",
        salary_type: "CTC",
        is_ot: "No",
        is_other_allowances: "No",
        other_allowance_type: ''
    });
    const [previous, setPrevious] = useState([]);

    useEffect(() => {
        if (id) handleGetOne();
    }, [id]);

    useEffect(() => {
        if (Number(techAssessment.offered_salary) >= 23447) {
            setTechAssessment((prev) => ({
                ...prev,
                is_esi: "No",
            }));
        } else {
            setTechAssessment((prev) => ({
                ...prev,
                is_esi: "Yes",
            }));
        }
    }, [techAssessment.offered_salary]);


    const handleGetOne = async () => {
        try {
            const res = await axios.get(
                `${backUrl}/api/emp/candidates/all_interview_levels/?candidate_id=${id}`,
                { headers: { Authorization: `Bearer ${authData?.access}` } }
            );
            const candidateData = res.data;
            setSingleData(candidateData);

            const currentLevel = candidateData.interview_levels?.find(
                (lvl) => lvl.level_number === lno
            );
            if (currentLevel) {
                setTechAssessment({
                    tech_qualification: currentLevel.tech_qualification || "",
                    tech_experience: currentLevel.tech_experience || "",
                    tech_knowledge: currentLevel.tech_knowledge || "",
                    tech_skills_rating: currentLevel.tech_skills_rating || "",
                    tech_attitude: currentLevel.tech_attitude || "",
                    tech_communication: currentLevel.tech_communication || "",
                    tech_time_management: currentLevel.tech_time_management || "",
                    tech_flexibility: currentLevel.tech_flexibility || "",
                    tech_commitment: currentLevel.tech_commitment || "",
                    present_salary: currentLevel.present_salary || "",
                    expected_salary: currentLevel.expected_salary || "",
                    offered_salary: currentLevel.offered_salary || "",
                    date_of_joining: currentLevel.date_of_joining || "",
                    is_pf: currentLevel.is_pf || "Yes",
                    is_esi: currentLevel.is_esi || "No",
                    salary_type: currentLevel.salary_type || "CTC",
                    is_ot: currentLevel.is_ot ? "Yes" : "No",
                    is_other_allowances: currentLevel.is_other_allowances ? "Yes" : "No",
                    other_allowance_type: currentLevel.other_allowance_type || "",
                });
                setData((prev) => ({
                    ...prev,
                    status: currentLevel.status || "",
                    remarks: currentLevel.remarks || "",
                }));
            }
        } catch (err) {
            console.error("Error fetching candidate details:", err);
            toast.error("Failed to fetch candidate details.");
        }
    };

    const handleFeedback = async () => {
        if (!data.status) {
            toast.warn("Please select a status (Selected, Rejected, or Hold)");
            return;
        }
        if (!data.remarks.trim()) {
            toast.warn("Remarks field cannot be empty");
            return;
        }
        if (data.status === "Selected") {
            if (!techAssessment.offered_salary) {
                toast.warn("Please enter Offered Salary for selected candidate");
                return;
            }
            if (!techAssessment.date_of_joining) {
                toast.warn("Please enter Date of Joining for selected candidate");
                return;
            }
        }

        try {
            if (showAlert === false) {
                const finalPayload = {
                    ...data,
                    ...techAssessment,
                    offered_notice_period: offered_notice_period,
                    date_of_joining:
                        data.status === "Selected" && techAssessment.date_of_joining
                            ? dayjs(techAssessment.date_of_joining).format("YYYY-MM-DD")
                            : null,
                };
                await axios.put(
                    `${backUrl}/api/emp/candidates/${id}/hod_review/`,
                    finalPayload,
                    { headers: { Authorization: `Bearer ${authData?.access}` } }
                );
                toast.success(
                    data.status === "Selected"
                        ? "Candidate Selected"
                        : data.status === "Rejected"
                            ? "Candidate Rejected"
                            : "Candidate in hold"
                );
            }
            else {
                alert("Please Fix the salary split for this candidate!")
            }

        } catch (err) {
            console.error("Error submitting feedback:", err);
            toast.error("Error submitting feedback. Please try again.");
        }
    };

    const handlePrevious = async () => {
        try {
            const filtered = singleData.interview_levels?.filter((item) => item.level_number !== lno) || [];
            if (filtered.length === 0) {
                toast.warn("No previous rounds found for this candidate!");
                return;
            }
            setPrevious(filtered);
            setViewPrevious(true);
        } catch (error) {
            console.error("Error fetching previous rounds:", error);
            toast.error("Failed to fetch previous rounds.");
        }
    };

    const personalFields = [
        { label: "Candidate Name", key: "candidate_name" },
        { label: "Mobile Number", key: "mobile_number" },
        { label: "Email Id", key: "email_id" },
        { label: "Aadhaar", key: "aadhaar" },
        { label: "Pan", key: "pan" },
        { label: "Address", key: "address", type: "textarea" },
        { label: "City", key: "city" },
        { label: "State", key: "state" },
        { label: "Pincode", key: "pincode" },
    ];

    const professionalFields = [
        { label: "Education Background", key: "education_background", type: "textarea" },
        { label: "Technical Background", key: "technical_background", type: "textarea" },
        { label: "Relevant Experience", key: "relevant_experience" },
        { label: "Total Experience", key: "total_experience" },
        { label: "Specification", key: "specification" },
        { label: "Present Salary", key: "present_salary" },
        { label: "Expected Salary", key: "expected_salary" },
        { label: "Notice Period", key: "notice_period" },
    ];

    const TechAssessment = () => {
        const options = ["Excellent", "Acceptable", "Average", "Below Average", "Poor"];

        const renderRadioGroup = (label, field) => (
            <div className="mb-4 d-flex flex-column align-items-start justify-content-between">
                {/* Label on the left */}
                <label className="form-label fw-bold mb-0" style={{ minWidth: "200px", textTransform: 'uppercase' }}>
                    {label}
                </label>

                {/* Options on the right */}
                <div id="tect-assessment-item" className="d-flex flex-wrap justify-content-around gap-3">
                    {options.map((option) => (
                        <label
                            key={option}
                            className="d-flex align-items-center"
                            style={{ cursor: "pointer", fontSize: '14px', fontWeight: 'normal' }}
                        >
                            <input
                                type="radio"
                                name={field}
                                value={option}
                                checked={techAssessment[field] === option}
                                onChange={() =>
                                    setTechAssessment((prev) => ({ ...prev, [field]: option }))
                                }
                                className="form-check-input me-1"
                            // style={{fontWeight:'lighter'}}
                            />
                            {option}
                        </label>
                    ))}
                </div>
            </div>
        );

        // if(techAssessment.is_esi === true && techAssessment.is_esi && techAssessment.salary_type==="")
        // {
        //     setShowCalculator(true)
        // }

        return (
            <>
                <ToastContainer position="top-right" autoClose={3000} />

                <div className="tech-assessment-section mt-4 bg-light">

                    {
                        authData.employee.is_superuser ? (
                            <h5 className="mb-4">HR Assessment</h5>
                        ) : (
                            <h5>Technical Assessment</h5>
                        )
                    }
                    {renderRadioGroup("Qualification", "tech_qualification")}
                    {renderRadioGroup("Experience", "tech_experience")}
                    {renderRadioGroup("Knowledge", "tech_knowledge")}
                    {renderRadioGroup("Skills", "tech_skills_rating")}
                    {renderRadioGroup("Attitude", "tech_attitude")}
                    {renderRadioGroup("Communication", "tech_communication")}
                    {renderRadioGroup("Time Management", "tech_time_management")}
                    {renderRadioGroup("Flexibility", "tech_flexibility")}
                    {renderRadioGroup("Commitment", "tech_commitment")}
                </div>
            </>
        );
    };

    console.log("SingleData : ", singleData)

    return (
        <div className="d-flex flex-column candidate-details-wrapper p-3">
            <ToastContainer position="top-right" autoClose={3000} />
            {viewPrevious ? (
                <PreviousRound id={id} previous={previous} onBack={() => setViewPrevious(false)} />
            ) : (
                <>
                    <div id="bread-container" className="mb-3">
                        <a className="bread-anchor" id="bread-acr" onClick={onBack}>
                            ← Back
                        </a>
                        <span className="no-anchor"> / </span>
                        <a className="bread-anchor" id="bread-acr" onClick={handlePrevious}>
                            Other Rounds
                        </a>
                    </div>
                    <Card className="m-3 p-3">
                        <Title level={5} style={{ textAlign: "center" }}>
                            Candidate Profile
                        </Title>
                        <h6 style={{ textAlign: "center" }}>Candidate for {singleData.designation} role</h6>

                        <Row gutter={[24, 16]} justify="center" className="mt-3">
                            <Space size="large" direction="horizontal" style={{ justifyContent: "center", display: "flex", marginTop: 32 }}>
                                <div
                                    style={{ textAlign: "center", cursor: "pointer" }}
                                    onClick={async () => {
                                        try {
                                            const photoUrl = singleData.candidate_photo
                                                ? `${backUrl}/${singleData.candidate_photo}`
                                                : candidateImg;
                                            const res = await fetch(photoUrl);
                                            if (!res.ok) throw new Error("Failed to fetch photo");
                                            const blob = await res.blob();
                                            const fileURL = window.URL.createObjectURL(blob);
                                            window.open(fileURL, "_blank");
                                            setTimeout(() => URL.revokeObjectURL(fileURL), 100000);
                                        } catch (error) {
                                            console.error("Error fetching photo:", error);
                                            toast.error("Failed to fetch candidate photo.");
                                        }
                                    }}
                                >
                                    <Image
                                        src={singleData.candidate_photo ? `${backUrl}/${singleData.candidate_photo}` : candidateImg}
                                        alt="Candidate"
                                        width={150}
                                        height={150}
                                        style={{ borderRadius: "50%", objectFit: "cover" }}
                                        preview={false}
                                    />
                                </div>
                                <div
                                    style={{ textAlign: "center", cursor: "pointer" }}
                                    onClick={async () => {
                                        try {
                                            const res = await fetch(`${backUrl}/${singleData.candidate_cv}`);
                                            if (!res.ok) throw new Error("Failed to fetch resume");
                                            const blob = await res.blob();
                                            const fileURL = window.URL.createObjectURL(blob);
                                            window.open(fileURL, "_blank");
                                            setTimeout(() => URL.revokeObjectURL(fileURL), 100000);
                                        } catch (error) {
                                            console.error("Error fetching resume:", error);
                                            toast.error("Failed to fetch candidate resume.");
                                        }
                                    }}
                                >
                                    <Image src={candidateCV} alt="Resume" width={30} height={30} preview={false} />
                                    <Text style={{ display: "block", marginTop: 8 }}>Resume</Text>
                                </div>
                            </Space>
                            <Divider />
                            <Col xs={24} md={12}>
                                <Card bordered={false} style={{ minHeight: 300 }}>
                                    {personalFields.map(({ label, key, type }, idx) => (
                                        <div key={idx} className="mb-3">
                                            <Text strong>{label}</Text>
                                            {type === "textarea" ? (
                                                <TextArea value={singleData[key] || ""} readOnly rows={3} style={{ marginTop: 4 }} />
                                            ) : (
                                                <Input value={singleData[key] || ""} readOnly style={{ marginTop: 4 }} />
                                            )}
                                        </div>
                                    ))}
                                </Card>
                            </Col>
                            <Col xs={24} md={12}>
                                <Card bordered={false} style={{ minHeight: 300 }}>
                                    {professionalFields.map(({ label, key, type }, idx) => {
                                        const value =
                                            key === "present_salary" || key === "expected_salary"
                                                ? singleData[key]
                                                    ? Math.round(singleData[key])
                                                    : ""
                                                : singleData[key] || "";
                                        return (
                                            <div key={idx} className="mb-3">
                                                <Text strong>{label}</Text>
                                                {type === "textarea" ? (
                                                    <TextArea value={value} readOnly rows={3} style={{ marginTop: 4 }} />
                                                ) : (
                                                    <Input value={value} readOnly style={{ marginTop: 4 }} />
                                                )}
                                            </div>
                                        );
                                    })}
                                </Card>
                            </Col>
                        </Row>
                        <Divider />
                        <div className="interview-feedback-container p-4 rounded shadow-sm bg-light mt-3">
                            <TechAssessment />
                            {data.status === "Selected" && (
                                <Space direction="vertical" style={{ width: "100%" }} size="middle">
                                    <div>
                                        <label>Present Salary</label>
                                        <Input value={Math.round(singleData.present_salary || 0)} readOnly />
                                    </div>
                                    <div>
                                        <label>Expected Salary</label>
                                        <Input value={Math.round(singleData.expected_salary || 0)} readOnly />
                                    </div>
                                    <div>
                                        <label>Offered Salary</label>
                                        {singleData.offered_salary !== null ? (
                                            <Input value={Math.round(singleData.offered_salary)} readOnly />
                                        ) : (
                                            <Input
                                                type="number"
                                                value={techAssessment.offered_salary}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setTechAssessment((prev) => ({
                                                        ...prev,
                                                        offered_salary: value,
                                                        // is_pf: value > 20999 ? "Yes" : "No",
                                                        // salary_type: value > 20999 ? "CTC" : "CTC",
                                                    }));
                                                }}
                                            />
                                        )}
                                        {/* <Button className="mt-2" onClick={() => {
                                            setShowCalculator(true);
                                            setShowAlert(false);
                                        }}>
                                            Salary Calculation
                                        </Button> */}
                                        <Modal
                                            open={showCalculator}
                                            onCancel={() => setShowCalculator(false)}
                                            footer={null}
                                            width={700}
                                        >
                                            <SalaryCalculator
                                                amount={singleData.offered_salary !== null ? singleData.offered_salary : Number(techAssessment.offered_salary) || 0} cid={id}
                                                is_pf={techAssessment.is_pf} is_esi={techAssessment.is_esi} salary_type={techAssessment.salary_type}
                                            />
                                        </Modal>
                                    </div>
                                    <div>
                                        <label>Notice Period</label>
                                        <Input value={singleData.notice_period || ""} readOnly />
                                    </div>
                                    {
                                        singleData.offered_notice_period ? (
                                            <div>
                                                <label>Offered Notice Period</label>
                                                <Input name="offered_notice_period" value={singleData.offered_notice_period} />
                                            </div>
                                        ) : (
                                            <div>
                                                <label>Offered Notice Period</label>
                                                <Input name="offered_notice_period" value={offered_notice_period || ""} onChange={(e) => setOfferedNoticePeriod(e.target.value)} />
                                            </div>
                                        )
                                    }

                                    <section
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-around",
                                            gap: "40px",
                                            padding: "20px",
                                            borderRadius: "12px",
                                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                            alignItems: "flex-start",
                                        }}
                                    >
                                        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                                            <label style={{ fontWeight: "bold", marginBottom: "4px" }}>PF eligible</label>
                                            <Radio.Group
                                                name="is_pf"
                                                value={techAssessment.is_pf}
                                                onChange={(e) => setTechAssessment({ ...techAssessment, is_pf: e.target.value })}
                                            >
                                                <Radio value="Yes">Yes</Radio>
                                                <Radio value="No">No</Radio>
                                            </Radio.Group>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                                            <label style={{ fontWeight: "bold", marginBottom: "4px" }}>ESI eligible</label>
                                            <Radio.Group
                                                name="is_esi"
                                                value={techAssessment.is_esi}
                                                onChange={(e) => setTechAssessment({ ...techAssessment, is_esi: e.target.value })}
                                            >
                                                <Radio value="Yes">Yes</Radio>
                                                <Radio value="No">No</Radio>
                                            </Radio.Group>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                                            <label style={{ fontWeight: "bold", marginBottom: "4px" }}>Salary Type</label>
                                            <Radio.Group
                                                name="salary_type"
                                                value={techAssessment.salary_type}
                                                onChange={(e) => setTechAssessment({ ...techAssessment, salary_type: e.target.value })}
                                            >
                                                <Radio value="Gross">Gross</Radio>
                                                <Radio value="Net">Net</Radio>
                                                <Radio value="CTC">CTC</Radio>
                                            </Radio.Group>
                                        </div>

                                        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                                            <label style={{ fontWeight: "bold", marginBottom: "4px" }}>
                                                OT eligible
                                            </label>

                                            <Radio.Group
                                                name="is_ot"
                                                value={techAssessment.is_ot}
                                                onChange={(e) =>
                                                    setTechAssessment({
                                                        ...techAssessment,
                                                        is_ot: e.target.value,
                                                    })
                                                }
                                            >
                                                <Radio value="Yes">Yes</Radio>
                                                <Radio value="No">No</Radio>
                                            </Radio.Group>

                                        </div>


                                        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                                            <label style={{ fontWeight: "bold", marginBottom: "4px" }}>Other Allowances</label>
                                            <Radio.Group
                                                name="is_other_allowances"
                                                value={techAssessment.is_other_allowances}
                                                onChange={(e) =>
                                                    setTechAssessment({
                                                        ...techAssessment,
                                                        is_other_allowances: e.target.value,
                                                    })
                                                }
                                            >
                                                <Radio value="Yes">Yes</Radio>
                                                <Radio value="No">No</Radio>
                                            </Radio.Group>

                                            {
                                                techAssessment.is_other_allowances === "Yes" && (
                                                    <>
                                                        <TextArea name="other_allowance_type" value={techAssessment.other_allowance_type} onChange={(e) => setTechAssessment({ ...techAssessment, other_allowance_type: e.target.value })} placeholder="Enter the type of allowance">

                                                        </TextArea>
                                                    </>
                                                )
                                            }
                                            {
                                                singleData?.other_allowance_type !== "" && (
                                                    <>
                                                        <TextArea name="other_allowance_type" value={singleData.other_allowance_type} >

                                                        </TextArea>
                                                    </>
                                                )

                                            }
                                        </div>

                                    </section>
                                    <center>
                                        <Button style={{ border: '2px solid green', color: "green" }} className="mt-2" onClick={() => {
                                            setShowCalculator(true);
                                            setShowAlert(false);
                                        }}>
                                            Fix Salary
                                        </Button>
                                    </center>
                                    <hr />
                                    <div>
                                        <label>Date of Joining</label>
                                        {singleData.date_of_joining !== null ? (
                                            <DatePicker
                                                value={moment(singleData.date_of_joining)}
                                                format="YYYY-MM-DD"
                                                style={{ width: "100%" }}
                                            />
                                        ) : (
                                            <DatePicker
                                                value={techAssessment.date_of_joining ? moment(techAssessment.date_of_joining) : null}
                                                format="YYYY-MM-DD"
                                                onChange={(date, dateString) =>
                                                    setTechAssessment((prev) => ({ ...prev, date_of_joining: dateString }))
                                                }
                                                style={{ width: "100%" }}
                                            />
                                        )}
                                    </div>
                                </Space>
                            )}
                            <Title level={5} style={{ textAlign: "center", margin: "1rem 0" }}>
                                Interview Feedback
                            </Title>
                            <div className="mb-3 d-flex flex-wrap gap-2 justify-content-center">
                                <Button
                                    type={data.status === "Selected" ? "primary" : "default"}
                                    style={data.status === "Selected" ? { backgroundColor: "#52c41a", borderColor: "#52c41a" } : {}}
                                    onClick={() => setData({ ...data, status: "Selected" })}
                                >
                                    Selected
                                </Button>
                                <Button
                                    type={data.status === "Rejected" ? "primary" : "default"}
                                    danger
                                    style={data.status === "Rejected" ? {} : { backgroundColor: "transparent" }}
                                    onClick={() => setData({ ...data, status: "Rejected" })}
                                >
                                    Rejected
                                </Button>
                                <Button
                                    type={data.status === "On-hold" ? "primary" : "default"}
                                    style={data.status === "On-hold" ? { backgroundColor: "#8c8c8c", borderColor: "#8c8c8c" } : {}}
                                    onClick={() => setData({ ...data, status: "On-hold" })}
                                >
                                    Hold
                                </Button>
                            </div>
                            <div className="mb-3">
                                <label className="fw-bold">Remarks</label>
                                <TextArea
                                    rows={3}
                                    value={data.remarks}
                                    onChange={(e) => setData({ ...data, remarks: e.target.value })}
                                />
                            </div>
                            <div style={{ textAlign: "center" }}>
                                <Button
                                    type="primary"
                                    onClick={handleFeedback}
                                    style={{ width: "fit-content", backgroundColor: "#0e497b" }}
                                >
                                    Submit
                                </Button>
                            </div>
                        </div>
                    </Card>
                </>
            )}
        </div>
    );
}
